import { render, staticRenderFns } from "./OrderListModal.vue?vue&type=template&id=1f17b3b2&"
import script from "./OrderListModal.vue?vue&type=script&lang=js&"
export * from "./OrderListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports